import { component as defineComponent } from 'flightjs';

export default defineComponent(function() {
    this.attributes({
        checkboxesSelector: ':checkbox',
        showMoreSelector: '[data-website-templates-more]',
    });

    this.updateCheckboxes = function() {
        if (this.$checkboxes.filter(':checked').length >= this.$node.data('max-selection')) {
            var $unchecked = this.$checkboxes.filter(':not(:checked)');
            $unchecked.closest('.field').attr('data-field-disabled', '');
            $unchecked.prop('disabled', true);
        } else {
            this.$checkboxes.closest('.field').removeAttr('data-field-disabled');
            this.$checkboxes.prop('disabled', false);
        }
    };

    this.showMoreTemplates = function() {
        this.$node.find('.matrix').removeClass('checkable-image-matrix--truncated-to-6');
        this.select('showMoreSelector').hide();
    };

    this.after('initialize', function() {
        this.$checkboxes = this.select('checkboxesSelector');
        this.updateCheckboxes();
        this.on('change', {
            checkboxesSelector: this.updateCheckboxes,
        });
        this.on('click', {
            showMoreSelector: this.showMoreTemplates,
        });
    });
});



// WEBPACK FOOTER //
// ./src/web/js/app/modules/website-template.js